module.exports = __webpack_public_path__ + "static/media/Parques.e63bdaf0.png";